/**
 * CENTRAL ENVIRONMENT CONFIGURATION
 *
 * To switch environments for a local command, set EXPO_PUBLIC_LAIWANI_ENV to:
 * 'local'   - Uses Production keys but FORCES connection to your local Mac Sandbox (Emulators).
 * 'staging' - Uses your laiwani-staging project in the cloud.
 * 'live'    - Uses your laiwani-service project in the cloud (PROD).
 */

const requestedEnv = process.env.EXPO_PUBLIC_LAIWANI_ENV;
const ACTIVE_ENV = ["local", "staging", "live"].includes(requestedEnv)
  ? requestedEnv
  : "live";

const configs = {
  local: {
    projectId: "laiwani-service",
    appId: "1:443552097290:web:7151cccfdde42def26ebf3",
    databaseURL:
      "https://laiwani-service-default-rtdb.asia-southeast1.firebasedatabase.app",
    storageBucket: "laiwani-service.firebasestorage.app",
    apiKey: "AIzaSyBwNLIxa-tCPmyC2ERYBLCjh5bPX0pm3x8",
    authDomain: "laiwani-service.firebaseapp.com",
    messagingSenderId: "443552097290",
    measurementId: "G-KK5ZYV8C28",
    projectNumber: "443552097290",
    version: "2",
    functionsEmulatorOrigin: "http://127.0.0.1:5001",
    functionsEmulatorRegion: "0",
    useEmulators: true, // FORCES connection to localhost
  },
  staging: {
    projectId: "laiwani-staging",
    appId: "", // TODO: Get from Firebase Console -> Project Settings
    databaseURL: "", // TODO: Get from Firebase Console -> Realtime Database
    storageBucket: "", // TODO: Get from Firebase Console -> Storage
    apiKey: "", // TODO: Get from Firebase Console -> Project Settings
    authDomain: "", // TODO: Get from Firebase Console -> Project Settings
    messagingSenderId: "438046804004", // Confirmed from project number
    useEmulators: false,
  },
  live: {
    projectId: "laiwani-service",
    appId: "1:443552097290:web:7151cccfdde42def26ebf3",
    databaseURL:
      "https://laiwani-service-default-rtdb.asia-southeast1.firebasedatabase.app",
    storageBucket: "laiwani-service.firebasestorage.app",
    apiKey: "AIzaSyBwNLIxa-tCPmyC2ERYBLCjh5bPX0pm3x8",
    authDomain: "laiwani-service.firebaseapp.com",
    messagingSenderId: "443552097290",
    measurementId: "G-KK5ZYV8C28",
    projectNumber: "443552097290",
    version: "2",
    useEmulators: false,
  },
};

export const EnvConfig = configs[ACTIVE_ENV];
export { ACTIVE_ENV };
